<div class="app-shell">
    <app-navbar></app-navbar>
    <mb-side-nav [expandedLogoSrc]="srcLogo.lg" [logoSrc]="srcLogo.sm">
        <router-outlet></router-outlet>
    </mb-side-nav>
</div>
